import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Button, ButtonProps, useTheme } from "@material-ui/core";
import { BeatLoader } from "react-spinners";

const useStyles = makeStyles((theme: Theme) => ({
  base: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 10,
    fontWeight: 700,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
}));

interface IPrimaryButtonProps extends ButtonProps {
  loading?: boolean;
}

export const PrimaryButton: FunctionComponent<IPrimaryButtonProps> = (props) => {
  const { loading, children, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Button {...rest} color="primary" variant="contained" className={`${classes.base} ${props.className}`}>
      {loading && <BeatLoader size={8} color={theme.palette.common.white} />}
      {!loading && children}
    </Button>
  );
};
